var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('h1',{staticClass:"proof-date-separator",attrs:{"data-proofs-date":_vm.date}},[_c('div',{staticClass:"sticky-date-content"},[_vm._v(" "+_vm._s(_vm._f("prettyDate")(_vm.date))+" "),_c('v-divider')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }